﻿$(function () {
  CustomerCard.init();
});

var CustomerCard =
  CustomerCard ||
  (function () {
    var customerNumber = '';
    var organizationNumber = '';
    var errorMessages = {
      delError: '',
      updateError: '',
    };

    function showAddOwnerLoader() {
      $('.js-add-owner-loader').show();
    }

    function hideAddOwnerLoader() {
      $('.js-add-owner-loader').hide();
    }

    function addOwner(userName) {
      showAddOwnerLoader();
      $.ajax({
        url: '/api/customer-card/add-owner',
        type: 'POST',
        data: {
          username: userName,
          customernumber: customerNumber,
          organizationnumber: organizationNumber,
        },
        dataType: 'json',
        success: function (data) {
          hideAddOwnerLoader();
          if (data) {
            if (data.error) {
              $('.js-add-owner-error').html(data.error);
            } else {
              $('.js-add-owner').addClass('hidden');
              $('#js-activated-confirmation').removeClass('hidden');
              setTimeout(function () {
                location.href = window.location;
              }, 2000);
            }
          } else {
            $('.js-add-owner-error').html('Kunde inte lägga till ägare');
          }
        },
        error: function () {
          hideAddOwnerLoader();
          $('.js-add-owner-error').html('Ett fel inträffade');
        },
      });
    }

    function checkUser(userName) {
      showAddOwnerLoader();
      $.ajax({
        url: '/api/customer-card/check-owner',
        type: 'POST',
        data: { username: userName, customernumber: customerNumber },
        dataType: 'json',
        success: function (data) {
          hideAddOwnerLoader();
          if (data) {
            if (data.error) {
              $('.js-add-owner-error').html(data.error);
              $('.js-add-owner-information').html('');
              $('.js-add-owner-save').addClass('hidden');
            } else {
              $('.js-add-owner-information').html(
                '<div class="existing-user js-add-owner-information"><h3 class="heading-title-3"> Användaren finns i LM2</h3><p> <strong>Namn:</strong> ' +
                  data.firstName +
                  ' ' +
                  data.lastName +
                  '</p><p> <strong>Telefon:</strong> ' +
                  data.telephone +
                  '</p><p> <strong>Mobil:</strong> ' +
                  data.mobile +
                  '</p><p> <strong>E-post:</strong> ' +
                  data.email +
                  '</p></div>',
              );
              $('.js-add-owner-save').removeClass('hidden');
              $('.js-add-owner-error').html();
            }
          } else {
            $('.js-add-owner-save').addClass('hidden');
          }
        },
        error: function () {
          hideAddOwnerLoader();
          $('.js-add-owner-error').html('Ett fel inträffade');
          $('.js-add-owner-information').html('');
          $('.js-add-owner-save').addClass('hidden');
        },
      });
    }

    function addOwnerEvents() {
      $('#js-add-owner-checkbox').change(function () {
        if ($(this).is(':checked')) {
          if (!$('#js-has-owner').val()) {
            $('.js-add-owner').removeClass('hidden');
          }
        } else {
          $('.js-add-owner').addClass('hidden');
          $('.js-add-owner-modal').show();
        }
      });

      $('.js-add-owner-check-user').click(function () {
        var email = $('.js-add-owner-epost').val();
        if (email) {
          checkUser(email);
        }
      });

      $('.js-add-owner-deactivate').click(function () {
        $.ajax({
          url: '/api/customer-card/deactivate-customer',
          type: 'POST',
          data: { customerNumber },
          dataType: 'json',
          success: function (data) {
            if (data && !data.error) {
              location.reload();
            } else {
              alert(data.error || 'Kunde inte inaktivera kund');
            }
          },
          error: function () {
            alert('Ett fel inträffade');
          },
        });
      });

      $('.js-add-owner-save').click(function () {
        var email = $('.js-add-owner-epost').val();
        if (email && customerNumber && organizationNumber) {
          addOwner(email);
        }
      });

      $('.js-add-owner-cancel, .js-add-owner-close').click(function () {
        $('.js-add-owner').addClass('hidden');
        var checkbox = $('#js-add-owner-checkbox');
        checkbox.prop('checked', false);
      });

      $("#cancel-btn").click(function () {
        var checkbox = $("#js-add-owner-checkbox");
        checkbox.prop("checked", true);
      });

      $('.js-add-owner-epost').keydown(function () {
        $('.js-add-owner-information').html('');
        $('.js-add-owner-save').addClass('hidden');
      });
    }

    function addProfileHandler() {
      var $userProfile = $('a.user-profile');
      $userProfile.each(function (idx, item) {
        $(item).click(function () {
          var selectedProfileId = $(item).closest('li.showcase').attr('data-value');
          var userName = $(item).attr('data-userName');
          var loader = $(item).closest('td').find('.loader-wrapper');
          var confirmPanel = $(item).closest('td').find('.confirm-panel .confirm-box');
          if (confirmPanel.length > 0) {
            var $confirmPanel = $(confirmPanel);
            $confirmPanel.show();
            $('input[type=reset]', $confirmPanel).click(function () {
              $confirmPanel.hide();
            });
            $('input[type=button]', $confirmPanel).click(function () {
              showLoader(loader);
              changeProfileForUser(
                userName,
                selectedProfileId,
                customerNumber,
                function () {
                  $confirmPanel.hide();
                },
                function () {
                  showErrorDialog(errorMessages.updateError);
                },
                function () {
                  hideLoader(loader);
                  $confirmPanel.hide();
                },
              );
            });
          }
        });
      });

      $('.js-disconnect-user-from-customer').click(function () {
        var userName = $(this).attr('data-userName');
        var userId = $(this).attr('data-userId');
        var userElement = $(this).closest('tr');
        var loader = $(userElement).find('.loader-wrapper');
        var $confirmDialog = $('#dg-del-user-confirmation');
        if ($confirmDialog.length > 0) {
          $confirmDialog.fadeIn();
          // event for confirmation dialog
          $('button.yes').click(function () {
            showLoader(loader);
            removeUserFromCustomer(
              userName,
              userId,
              customerNumber,
              function () {
                $(userElement).remove();
              },
              function () {
                showErrorDialog(errorMessages.delError);
              },
              function () {
                hideLoader(loader);
              },
            );
          });
        }
      });
    }

    function removeUserFromCustomer(
      userName,
      userId,
      customerNumber,
      successCallBack,
      failCallBack,
      completeCallBack,
    ) {
      $.ajax({
        url:
          '/api/customer-card/remove-user?userName=' +
          userName +
          '&userId=' +
          userId +
          '&customerNo=' +
          customerNumber,
        type: 'GET',
        dataType: 'json',
        success: function (data) {
          if (data) {
            successCallBack();
          } else {
            failCallBack();
          }
        },
        error: function (jqXHR, textStatus, errorThrown) {
          failCallBack();
        },
        complete: function () {
          completeCallBack();
        },
      });
    }
    function showLoader(loader) {
      if (loader != undefined) {
        $(loader).show();
      }
    }

    function hideLoader(loader) {
      if (loader != undefined) {
        $(loader).hide();
      }
    }

    function changeProfileForUser(
      userName,
      profileId,
      customerNo,
      successCallBack,
      failCallBack,
      completeCallBack,
    ) {
      $.ajax({
        url:
          '/api/customer-card/change-profile?userName=' +
          userName +
          '&profileId=' +
          profileId +
          '&customerNo=' +
          customerNo,
        type: 'GET',
        dataType: 'json',
        success: function (data) {
          if (data) {
            successCallBack();
          } else {
            failCallBack();
          }
        },
        error: function (jqXHR, textStatus, errorThrown) {
          failCallBack();
        },
        complete: function () {
          completeCallBack();
        },
      });
    }

    function showErrorDialog(errorMess) {}

    var init = function () {
      customerNumber = $('input#customer-no') ? $('input#customer-no').val() : '';
      organizationNumber = $('input#org-no') ? $('input#org-no').val() : '';
      addProfileHandler();
      addOwnerEvents();
    };
    return {
      init: init,
    };
  })();
